import Title from "antd/lib/typography/Title";

export function PageTitle(props: { title: string }) {
    const { title } = props;

    // <Breadcrumb style={{ margin: '16px 0' }}>
    //     <Breadcrumb.Item>User</Breadcrumb.Item>
    //     <Breadcrumb.Item>Bill</Breadcrumb.Item>
    // </Breadcrumb>
    return <Title>{title}</Title>
}